import { AB_EXPERIMENT_DEFAULTS } from './constants';
import { IAbExperimentsState } from './types';

export function abExperiments(state: IAbExperimentsState) {
  return state || AB_EXPERIMENT_DEFAULTS;
}
